import React from "react";
import { X } from "lucide-react";
import { FilterChip } from "../Types/TalentIntelligenceTypes";

interface FilterChipProps {
  chip: FilterChip;
  onRemove: (chip: FilterChip) => void;
}

const CATEGORY_COLORS: Record<string, string> = {
  Keyword: "bg-indigo-50 text-indigo-700 border-indigo-200",
  Experience: "bg-blue-50 text-blue-700 border-blue-200",
  Role: "bg-violet-50 text-violet-700 border-violet-200",
  Leadership: "bg-fuchsia-50 text-fuchsia-700 border-fuchsia-200",
  "Team Size": "bg-purple-50 text-purple-700 border-purple-200",
  "Business Impact": "bg-emerald-50 text-emerald-700 border-emerald-200",
  Skills: "bg-cyan-50 text-cyan-700 border-cyan-200",
  Industry: "bg-teal-50 text-teal-700 border-teal-200",
  Company: "bg-sky-50 text-sky-700 border-sky-200",
  Location: "bg-amber-50 text-amber-700 border-amber-200",
  Availability: "bg-orange-50 text-orange-700 border-orange-200",
  "Work Mode": "bg-lime-50 text-lime-700 border-lime-200",
  "Nexgent Signal": "bg-rose-50 text-rose-700 border-rose-200",
  "Score": "bg-slate-100 text-slate-700 border-slate-300",
  "Recency": "bg-slate-100 text-slate-700 border-slate-300",
};

export const FilterChipView: React.FC<FilterChipProps> = ({ chip, onRemove }) => {
  const color = CATEGORY_COLORS[chip.category] || CATEGORY_COLORS.Score;
  return (
    <span
      className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full border text-xs font-semibold ${color}`}
    >
      <span className="opacity-60 font-medium">
        {chip.category}:{" "}
      </span>
      {chip.label}
      <button
        type="button"
        onClick={() => onRemove(chip)}
        className="ml-0.5 rounded-full p-0.5 hover:bg-black/10 transition-colors"
        aria-label={`Remove ${chip.label}`}
      >
        <X size={12} />
      </button>
    </span>
  );
};

export default FilterChipView;